<section class="checklist-execution-container" *ngIf="!isLoadingLabels && !isLoadingChecklistData && checklist != undefined">
	<header>
		<h1>{{ labels.lbl_checklist }} - {{ checklist.name }}</h1>

		<div class="under-title">
			<nav class="navigation">
				<a [routerLink]="'/checklist'">< {{ labels.lbl_checklist }}</a>
				<a [routerLink]="'/checklist/execute/' + checklist.id">< {{ checklist.name }}</a>
			</nav>
		</div>
	</header>
	<div class="time" *ngIf="checklist.status.toUpperCase() === 'RUNNING'">
		<div class="dotted-input-container">
			<span>{{ labels['lbl_data_inicio_checklist'] }}</span>
			<input [value]="DateService.formatDate(checklist.start_date.toString())" disabled />
		</div>
		<div></div>
		<div class="dotted-input-container">
			<span>{{ labels['lbl_data_limite_checklist'] }}</span>
			<input [value]="DateService.formatDate(checklist.expiration_date.toString())" disabled />
		</div>
	</div>

	<div class="time" *ngIf="checklist.status.toUpperCase() !== 'RUNNING'">
		<div class="dotted-input-container">
			<span>{{ labels['lbl_data_proxima_execucao'] }}</span>
			<input [value]="DateService.formatDate(checklist.start_date.toString())" disabled />
		</div>
		<div></div>
		<div></div>
	</div>
	<main>
		<div class="step-container">
			<div *ngFor="let step of checklist.steps; let index = index">
				<div class="step-header" [ngClass]="step.status.toUpperCase()">
					<span>{{ step.name }}</span>
					<span *ngIf="step.status.toUpperCase() === ''">{{ labels['lbl_geral_aguardando_execucao'] }}</span>
					<span *ngIf="step.status.toUpperCase() === 'WAITING'">{{ labels['lbl_geral_aguardando'] }}</span>
					<span *ngIf="step.status.toUpperCase() === 'RUNNING'">{{ labels['lbl_chamado_tarefa_em_execucao'] }}</span>
					<span *ngIf="step.status.toUpperCase() === 'COMPLETE'">{{ labels['lbl_geral_executada'] }}</span>
					<span *ngIf="step.status.toUpperCase() === 'FAIL'">{{ labels['lbl_geral_falha'] }}</span>
				</div>
				<div class="step-body" *ngIf="step.status.toUpperCase() === 'FAIL' && checklist.last_fail_request != undefined">
					{{ labels['lbl_chamado_falha_etapa_aberto'] }}: {{ checklist.last_fail_request.id }}
				</div>
				<div class="step-body" *ngIf="checklist.status.toUpperCase() === 'RUNNING' && index == currentStepIndex">
					<span>{{ labels['lbl_geral_procedimentos'] }}</span>
					<textarea disabled>{{ step.procedure }}</textarea>
					<div class="button-container">
						<button [ngClass]="{ disabled: isLoadingSuccess || isLoadingFail }" class="danger" (click)="stepFail()">
							{{ labels['lbl_geral_falha'] }}
							<cpi-dot-bounce-loading-effect
								[color]="'var(--const-white)'"
								*ngIf="isLoadingFail"></cpi-dot-bounce-loading-effect>
						</button>
						<button [ngClass]="{ disabled: isLoadingSuccess || isLoadingFail }" class="success" (click)="stepSuccess()">
							{{ labels['lbl_geral_sucesso'] }}
							<cpi-dot-bounce-loading-effect
								[color]="'var(--const-white)'"
								*ngIf="isLoadingSuccess"></cpi-dot-bounce-loading-effect>
						</button>
					</div>
				</div>
			</div>
		</div>
	</main>
</section>
